<div class="card cumulative-return-chart h-100">
  <div class="card-body">
    <div class="card-head">
      <div class="card-title">
        Cumulative return
        @if (benchmark?.index_name_short) {
          <span class="hint"
            >· Portfolio vs {{ benchmark.index_name_short }}</span
          >
        }
      </div>
    </div>
    @if (loaded && internalReady()) {
      <highcharts-chart
        [options]="chartOptions"
        [constructorType]="chartConstructor"
        (chartInstance)="setChartInstance($event)"
        style="width: 100%; height: auto; display: block"
      ></highcharts-chart>
    } @else {
      <app-chart-placeholder [loaded]="false"></app-chart-placeholder>
    }
  </div>
</div>
